// AtRiskBanner — the strip under the customer window's header when C's queue has
// an open issue on this account: the issue in their words, how long it has been
// open, who owns it, one action. Renders nothing while the retention route does
// not exist, and nothing when the account is clear.
import React, { useEffect, useState } from "react";
import { AlertTriangle, ChevronDown, ChevronUp } from "lucide-react";
import { fetchCustomerIssues } from "../../../api/retentionApi";
import IssueCard, { slaSentence } from "./IssueCard";
import "./atRisk.css";

export default function AtRiskBanner({ customerId, onAction, vocabulary = {} }) {
  const [issues, setIssues] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    setIssues(null);
    fetchCustomerIssues(customerId)
      .then((rows) => { if (alive) setIssues(rows); })
      .catch(() => { if (alive) setIssues(null); });
    return () => { alive = false; };
  }, [customerId]);

  const openIssues = (issues || []).filter((i) => i.status !== "resolved");
  if (!openIssues.length) return null;
  const lead = openIssues[0];
  const noun = vocabulary.account || "account";

  return (
    <section className={`atrisk${open ? " is-open" : ""}`} aria-label={`At-risk ${noun}`}>
      <button type="button" className="atrisk__row" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <AlertTriangle size={16} className="atrisk__icon" aria-hidden="true" />
        <span className="atrisk__text">
          <strong>At risk</strong>
          <span className="atrisk__issue"> · {lead.title || lead.issue || "Open issue"}</span>
          <span className="atrisk__meta"> · {slaSentence(lead) || "open"}{openIssues.length > 1 ? ` · ${openIssues.length - 1} more` : ""}</span>
        </span>
        {open ? <ChevronUp size={16} aria-hidden="true" /> : <ChevronDown size={16} aria-hidden="true" />}
      </button>
      {open ? (
        <div className="atrisk__body">
          {openIssues.map((i) => <IssueCard key={i.id} issue={i} onAction={onAction} compact />)}
        </div>
      ) : null}
    </section>
  );
}
